import clsx from 'clsx';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export function TabLink(props: {
  children: ReactNode;
  active: boolean;
  to: string;
}) {
  return (
    <Link to={props.to}>
      <li
        className={clsx(
          'px-3 font-medium cursor-pointer border-b-[3px] pb-1 transition-colors text-sm select-none',
          props.active
            ? 'text-slate-700 border-slate-700'
            : 'text-slate-500 border-slate-300 hover:text-slate-600 hover:border-slate-400',
        )}
      >
        {props.children}
      </li>
    </Link>
  );
}
